<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Driver Payment Types</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="createRecord">Add</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <template v-if="user.type === 'admin'">
                            <th>Company</th>
                        </template>
                        <th>Driver</th>
                        <th>Name</th>
                        <th>Last 5</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="record in records" v-if="records.length" class="text-left">
                        <template v-if="user.type === 'admin'">
                            <td>{{ record.company?.company_name ?? '' }}</td>
                        </template>
                        <td>{{ (record.driver?.user?.first_name || record.driver?.first_name || '') + ' ' + (record.driver?.user?.last_name || record.driver?.last_name || '') }}</td>
                        <td>{{ record.name }}</td>
                        <td>{{ record.last5 }}</td>
                        <td>{{ record.description }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editRecord(record)">Edit
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteRecord(record)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else class="text-center" colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchRecords"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Creat_Edit v-if="dialogSwitch"
                v-model="dialogSwitch"
                :record="selectedRecord"
                @addRecord="addRecord"
                @updateRecord="updateRecord"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Creat_Edit from "@/components/dialogs/drivers/PaymentType_Create_Edit.vue";

const {user} = useAuthStore();
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const records = ref([]);
const dialogSwitch = ref(false);
const selectedRecord = ref(null);
const {showSnackbar} = useSnackbarStore();

onMounted(() => {
    fetchRecords();
});

const fetchRecords = () => {
    send('get', `driver-payment-types`)
        .then((response) => {
            records.value = response.data.data.data ?? [];
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Driver payment types could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addRecord = (record) => {
    records.value.unshift(record);
}
const createRecord = () => {
    selectedRecord.value = null;
    dialogSwitch.value = true;
}
const editRecord = (record) => {
    selectedRecord.value = record;
    dialogSwitch.value = true;
}
const updateRecord = (record) => {
    records.value.map((comp, index) => {
        if (comp.id === record.id) {
            records.value[index] = record;
        }
    });
}
const deleteRecord = (record) => {
    if (confirm(`Are you sure to delete "${record.name}" record?`)) {
        send('delete', `driver-payment-types/${record.id}`)
            .then((response) => {
                if (response.data.success) {
                    records.value.map((item, index) => {
                        if (item.id === record.id) {
                            records.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${record.name}" driver payment type could not be deleted`, 'error')
                }
            })
    }
}
</script>
